
import { RSAA } from 'redux-api-middleware';
import config from 'config';


export const getActiveRadarList = (pageSize, page, sorted, filtered) => (dispatch, getState) => {
  const rsaaObject = {
    [RSAA]: {
      endpoint: `${config.apiRoot}/cat/active-radar`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ pageSize, page, sorted, filtered }),
      types: [
        'GET_ACTIVE_RADAR_DRUGS_REQUEST',
        {
          type: 'GET_ACTIVE_RADAR_DRUGS_SUCCESS',
          payload: async (action, state, res) => {
            const data = await res.json();
            return { pageSize: pageSize, sorted: sorted, filtered: filtered,...data };
          }
        },
        'GET_ACTIVE_RADAR_DRUGS_FAILURE'
      ],
    }
  }
  return dispatch(rsaaObject);
}

export const refreshActiveRadarList = () => (dispatch, getState) => {
  const {sorted,filtered,pageSize} = getState().activeRadar;
  dispatch(getActiveRadarList(pageSize, 0, sorted, filtered))
}
